var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13, _g3, _g4, _path14, _g5, _path15, _path16, _path17, _path18, _path19, _g6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 32C25.8366 32 33 24.8366 33 16C33 7.16344 25.8366 0 17 0C8.16344 0 1 7.16344 1 16C1 24.8366 8.16344 32 17 32Z",
    fill: "white",
    fillOpacity: 0.08
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3 8.63855C21.3135 8.25031 21.3981 7.87731 21.5005 7.51103C21.6434 6.99933 21.8083 6.49353 21.9733 5.98857C22.0452 5.76697 22.1424 5.55382 22.2261 5.33644C22.4038 4.87462 22.9045 4.67331 23.3528 4.84755C23.8036 5.02348 24.021 5.53605 23.8307 5.99196C23.6269 6.48084 23.4222 6.97058 23.1836 7.44253C22.9197 7.96613 22.6474 8.48966 22.2727 8.94724C22.1729 9.06908 22.0544 9.18071 21.931 9.27881C21.6823 9.47594 21.4446 9.31947 21.3719 9.07248C21.3288 8.93371 21.322 8.78404 21.3 8.63855ZM23.0339 5.77204C23.0584 5.83971 23.072 5.8913 23.0982 5.93613C23.105 5.94713 23.1625 5.94543 23.1803 5.93021C23.2978 5.8304 23.396 5.71114 23.4035 5.55128C23.4061 5.50138 23.3638 5.4168 23.3249 5.40495C23.2784 5.39057 23.1845 5.42017 23.1608 5.46078C23.1016 5.55635 23.0728 5.67054 23.0339 5.77204Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3867 6.18819C19.3512 6.68469 19.3267 7.20234 19.2725 7.71744C19.2429 8.00163 19.1887 8.28751 19.0331 8.5396C18.8953 8.76457 18.6702 8.81111 18.491 8.61653C18.3548 8.46941 18.2279 8.28921 18.1653 8.10058C18.0359 7.71234 17.9336 7.31228 17.8557 6.90967C17.7644 6.44109 17.7052 5.96573 17.6443 5.49122C17.6121 5.24424 17.5952 4.99472 17.5927 4.74521C17.5868 4.26139 18.0562 3.85624 18.5392 3.91629C18.9824 3.97127 19.3063 4.31299 19.3292 4.76381C19.3529 5.23155 19.3672 5.69845 19.3867 6.18819ZM18.7912 4.66485C18.7887 4.52867 18.7142 4.42041 18.617 4.4221C18.5138 4.42378 18.4504 4.5236 18.4766 4.66908C18.4935 4.76296 18.5223 4.85855 18.5637 4.94397C18.6069 5.03194 18.6914 5.02602 18.7261 4.93382C18.7582 4.8484 18.7701 4.75451 18.7912 4.66485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4872 8.89377C27.4906 9.18978 27.3985 9.41652 27.1946 9.57547C26.3851 10.2073 25.5241 10.7597 24.5988 11.2071C24.3772 11.3145 24.1361 11.3957 23.8951 11.4422C23.4375 11.531 23.3343 11.1707 23.473 10.8485C23.5922 10.5727 23.7698 10.3359 23.972 10.1194C24.6224 9.42155 25.3389 8.79651 26.106 8.23063C26.6135 7.85592 27.2953 8.09618 27.467 8.70684C27.4848 8.77788 27.4822 8.85488 27.4872 8.89377ZM27.0347 8.96141C27.0373 8.82612 26.9561 8.77278 26.8427 8.81677C26.6972 8.87344 26.6059 8.99017 26.5433 9.12638C26.5036 9.21351 26.5433 9.26507 26.633 9.23207C26.7564 9.1873 26.8723 9.11703 26.9857 9.04769C27.0161 9.03076 27.0263 8.97834 27.0347 8.96141Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5311 10.2389C20.5328 9.87007 20.8407 9.56981 21.2154 9.57151C21.5791 9.57321 21.8777 9.8836 21.8802 10.2617C21.8819 10.6237 21.5707 10.9266 21.2027 10.9198C20.8305 10.9139 20.5294 10.6085 20.5311 10.2389ZM21.5656 10.1314C21.5495 10.0113 21.5064 9.94792 21.4209 9.96145C21.382 9.96733 21.3296 10.0316 21.3254 10.0739C21.3161 10.1585 21.3778 10.2152 21.4615 10.2076C21.503 10.2042 21.5402 10.1518 21.5656 10.1314Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4865 9.72068C19.4848 10.0768 19.1651 10.399 18.8106 10.3872C18.4512 10.3745 18.1382 10.1115 18.1408 9.69447C18.1433 9.33329 18.4453 9.03473 18.8183 9.03473C19.1812 9.03473 19.4882 9.35022 19.4865 9.72068ZM19.0069 9.58787C19.028 9.55741 19.0797 9.51597 19.0805 9.47368C19.0822 9.38826 19.0137 9.33584 18.9333 9.34682C18.8919 9.35277 18.8284 9.41114 18.8259 9.44917C18.82 9.53715 18.8936 9.57016 19.0069 9.58787Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6821 12.5753C22.3632 12.5964 22.0079 12.3123 22.0105 11.8978C22.013 11.4986 22.3598 11.2313 22.6829 11.2296C23.0526 11.2271 23.3621 11.5536 23.3596 11.9062C23.357 12.2818 23.039 12.5956 22.6821 12.5753ZM22.8073 11.8885C22.88 11.9502 22.9223 12.0162 22.9713 12.0221C23.0534 12.0323 23.1007 11.9528 23.0847 11.8826C23.0737 11.8326 23.0103 11.7667 22.9646 11.7616C22.924 11.7574 22.8766 11.8285 22.8073 11.8885Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0339 5.77259C23.0728 5.67109 23.1024 5.5569 23.1599 5.46048C23.1836 5.42073 23.2775 5.39027 23.324 5.40465C23.3629 5.4165 23.4052 5.50108 23.4027 5.55098C23.395 5.71169 23.2969 5.83011 23.1794 5.92991C23.1616 5.94514 23.1041 5.94683 23.0973 5.93583C23.0711 5.89185 23.0584 5.84026 23.0339 5.77259Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7912 4.6649C18.7701 4.7554 18.7582 4.84844 18.7261 4.93471C18.6923 5.02691 18.6069 5.03283 18.5637 4.94487C18.5223 4.85859 18.4935 4.76386 18.4766 4.66997C18.4504 4.52449 18.5129 4.42468 18.617 4.42299C18.7142 4.42045 18.7887 4.52872 18.7912 4.6649Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0347 8.96092C27.0262 8.97785 27.016 9.03034 26.9864 9.04805C26.8731 9.11662 26.7572 9.18766 26.6338 9.2325C26.5441 9.26459 26.5043 9.21302 26.5441 9.12675C26.6067 8.99053 26.698 8.87387 26.8435 8.81713C26.9568 8.77237 27.0372 8.82563 27.0347 8.96092Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5656 10.1314C21.5403 10.1516 21.5031 10.2033 21.4608 10.2074C21.377 10.2159 21.3153 10.1584 21.3246 10.0739C21.3288 10.0316 21.3813 9.96725 21.4201 9.96138C21.5064 9.94785 21.5496 10.0121 21.5656 10.1314Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.007 9.58837C18.8937 9.57059 18.8201 9.53758 18.826 9.45046C18.8285 9.41242 18.892 9.35405 18.9334 9.34817C19.0138 9.33712 19.0823 9.38961 19.0806 9.47503C19.0797 9.51647 19.0282 9.55791 19.007 9.58837Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8073 11.8886C22.8766 11.8294 22.924 11.7575 22.9646 11.7616C23.0103 11.7659 23.0728 11.8327 23.0847 11.8826C23.1007 11.9528 23.0543 12.0315 22.9713 12.0222C22.9223 12.0154 22.88 11.9503 22.8073 11.8886Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2053 8.77185C14.2053 8.77185 13.839 9.49166 13.7468 10.2377C13.6546 10.9837 13.5768 13.3655 13.5768 13.3655L14.4801 13.012L14.2053 8.77185Z",
    fill: "#32280E"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35693 16.3053C9.35693 16.3053 8.31398 11.7209 9.5802 11.1524C10.7686 10.6188 12.7817 13.6248 12.7817 13.6248L14.256 12.9845C14.256 12.9845 13.9506 10.5333 13.9557 9.95902C13.9641 8.94568 14.3118 8.53208 14.5511 8.46103C14.8928 8.35953 15.3581 8.69535 16.1032 9.88712C16.8484 11.0789 17.3542 12.0465 17.3542 12.0465C17.3542 12.0465 18.2178 11.6642 19.2159 12.362C20.214 13.059 21.2856 13.8786 22.1645 15.2039C23.0433 16.5294 23.4899 18.2422 23.4899 18.2422C23.4899 18.2422 22.0604 23.6478 21.1663 24.9589C20.2724 26.27 20.1091 26.7165 19.5432 27.2671C18.9774 27.8178 17.8457 28.4285 16.7139 28.3845C15.5822 28.3405 13.9142 27.4913 13.3332 27.1487C12.752 26.8062 12.1118 26.2851 12.1118 26.2851C12.1118 26.2851 10.6824 26.2851 9.71386 25.809C8.74621 25.3328 7.89706 24.5428 7.86745 22.9052C7.83784 21.2669 7.98666 20.388 8.37405 19.2563C8.76144 18.1246 9.35693 16.3053 9.35693 16.3053Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.739 16.0594C10.5673 16.0341 10.4193 15.9267 10.3423 15.771C10.1994 15.4826 10.0124 14.8601 10.0099 13.8459C10.0057 12.4529 10.0437 12.518 10.3127 12.3268C10.5817 12.1357 11.0765 12.474 11.7185 13.2987C12.3605 14.1233 12.9619 14.6004 12.3757 15.2043C11.8175 15.7786 11.4757 15.9444 11.0943 16.04C10.9581 16.0738 10.8372 16.0738 10.739 16.0594Z",
    fill: "#A5A5A8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2219 9.50286C15.2219 9.50286 15.4842 9.31848 16.0365 10.3783C16.5888 11.4381 17.1352 12.2856 16.7114 12.5648C16.2877 12.8439 15.6237 12.9944 15.4232 12.7153C15.2228 12.4362 15.0883 11.9236 15.0443 11.3044C14.9995 10.6853 14.9217 9.67541 15.0443 9.59168C15.1661 9.50873 15.2219 9.50286 15.2219 9.50286Z",
    fill: "#A5A5A8"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7445 20.3462C15.7445 20.3462 16.1911 20.3588 16.5997 20.155C17.0082 19.9511 19.2159 18.8152 20.071 18.4447C20.9261 18.0743 23.4399 17.143 23.8611 18.4447C24.2824 19.7464 24.065 22.0428 23.3122 23.09C22.5594 24.1363 22.0875 24.6083 20.5176 24.774C18.9477 24.9399 16.8298 25.0802 15.1711 24.7106C13.5124 24.3401 12.5803 23.6897 12.2615 23.2431C11.9426 22.7965 10.5774 20.9458 11.4063 19.6703C12.2361 18.394 14.1756 19.5172 14.1756 19.5172L15.7445 20.3462Z",
    fill: "#A5A5A8"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5734 16.6591C13.5734 16.6591 14.2306 15.7472 14.8836 16.1566C15.5366 16.566 14.7398 17.7612 14.4962 17.932C14.2526 18.1029 13.8754 18.5089 13.3417 17.9633C12.9906 17.6055 13.5734 16.6591 13.5734 16.6591Z",
    fill: "#A5A5A8"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8826 14.8654C18.8826 14.8654 19.111 14.2522 19.7107 14.2183C20.3112 14.1844 20.9118 14.4162 20.9169 14.983C20.9228 15.5496 20.1522 15.6114 19.8977 15.6004C19.643 15.5894 19.1668 15.4701 18.9918 15.3001C18.8167 15.1301 18.8826 14.8654 18.8826 14.8654Z",
    fill: "#A5A5A8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8826 14.8654C18.8826 14.8654 19.111 14.2522 19.7107 14.2183C20.3112 14.1844 20.9118 14.4162 20.9169 14.983C20.9228 15.5496 20.1522 15.6114 19.8977 15.6004C19.643 15.5894 19.1668 15.4701 18.9918 15.3001C18.8167 15.1301 18.8826 14.8654 18.8826 14.8654Z",
    fill: "#A5A5A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3844 18.5929C15.3844 18.5929 15.7869 18.7029 15.9493 18.5506C16.1117 18.3984 15.9755 18.263 15.9755 18.263C15.9755 18.263 16.3266 18.148 16.7554 18.263C17.1842 18.3781 17.2274 18.6648 17.1174 18.7748C17.0074 18.8847 16.5769 19.1478 16.0593 19.0953C15.5408 19.0429 15.3793 18.8568 15.3446 18.7706C15.3006 18.6564 15.3844 18.5929 15.3844 18.5929Z",
    fill: "#000106"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9749 17.6666C18.9749 17.6666 19.3529 17.7478 19.5263 17.6522C19.6718 17.5719 19.7124 17.473 19.6507 17.4036C19.589 17.3342 19.5881 17.3342 19.5881 17.3342C19.5881 17.3342 20.0212 17.2438 20.3849 17.3342C20.7486 17.4247 20.8323 17.6878 20.7173 17.8121C20.6022 17.9364 20.2978 18.1792 19.7294 18.1606C19.2126 18.1437 19.0045 18.0202 18.9495 17.8815C18.8945 17.7428 18.9749 17.6666 18.9749 17.6666Z",
    fill: "#000106"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8071 19.2565C19.8071 19.2565 20.0659 18.6856 21.1545 18.4268C22.2431 18.168 22.8199 18.4607 22.8402 18.9318C22.8605 19.4029 22.5213 20.796 22.0105 20.8958C21.4996 20.9956 20.2588 20.4247 20.0862 20.2589C19.9137 20.0931 19.7546 19.9205 19.7149 19.6947C19.6743 19.4689 19.8071 19.2565 19.8071 19.2565Z",
    fill: "#12121A"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_936_5275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4514 9.86136L16.3084 11.2418",
    stroke: "white",
    strokeWidth: 0.119411
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_936_5275",
    x: 12.6766,
    y: 7.87168,
    width: 2.70368,
    height: 6.39403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.450086,
    result: "effect1_foregroundBlur_936_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_936_5275",
    x: 10.0096,
    y: 11.7971,
    width: 3.08211,
    height: 4.27138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.477644,
    dy: -0.477644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.238822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_936_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_936_5275",
    x: 14.9784,
    y: 9.01293,
    width: 2.36166,
    height: 3.851,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.477644,
    dy: -0.477644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.238822
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_936_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_936_5275",
    x: 13.2292,
    y: 15.8121,
    width: 2.14472,
    height: 2.42611,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.238822,
    dy: -0.238822
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.179116
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.423529 0 0 0 0 0.431373 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_936_5275"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_936_5275",
    x: 15.0425,
    y: 9.47163,
    width: 1.67485,
    height: 2.15991,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.179116,
    result: "effect1_foregroundBlur_936_5275"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_936_5275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonk);
export default __webpack_public_path__ + "static/media/BONK.d31ea93294fde267d874fb220776ce9f.svg";
export { ForwardRef as ReactComponent };